import units from '@/sui/data/units'
import assert from '@/sui/tools/assert'
import modules from '@/sui/data/modules'
import go from '@/gojs/go'

const missingDate = '2019-01-01T12:00:00.692052777+01:00'

const unitList = {
  clientToServer2019: function (list) {
    const result = []
    list.forEach(
      u => {
        const t = u.ufType
        const target = result.find(r => r.t === t)
        if (target == null) {
          result.push(
            {
              t: t,
              ufs: [ u.name ]
            }
          )
        } else {
          target.ufs.push(u.name)
        }
      }
    )
    return result
  },

  serverToClient2019: function (list) {
    const result = []
    list.forEach(
      u => {
        const type = u.t
        u.ufs.forEach(
          uf => {
            result.push({ name: uf, ufType: type })
          }
        )
      }
    )
    return result
  }
}

function splitReaNeoDia (list) {
  const rea = []
  const dia = []
  const neo = []
  const uy = units['2019']
  list.forEach(
    u => {
      const t = u.ufType
      assert(uy.isInfADI(t))
      if (uy.isDia(t)) {
        dia.push(u)
      } else if (uy.isNeo(t)) {
        neo.push(u)
      } else if (uy.isMix(t)) {
        neo.push(u)
        rea.push(u)
      } else {
        rea.push(u)
      }
    }
  )

  return {
    rea: rea,
    dia: dia,
    neo: neo
  }
}

function getMembers (s, t) {
  const result = []
  result.push(
    {
      user: {
        id: s.referent.id,
        name: s.referent.name,
        firstName: s.referent.firstName,
        emails: s.referent.emails
      },
      role: -1
    }
  )

  if (s.members[t] != null) {
    s.members[t].forEach(
      m => {
        result.push(m)
      }
    )
  }
  return result
}

function createModule (s, t, ufs) {
  return {
    registration: missingDate,
    ufs: ufs,
    members: getMembers(s, t)
  }
}

function serverToClient (s) {
  const reaSink = s.modules.reaSink
  if (reaSink != null) {
    reaSink.ufs = [reaSink.uf]
  }

  if (s.modules.results == null) {
    s.modules.results = {
      members: [
        {
          user: s.registrator,
          role: -1
        }
      ]
    }
  }
  return s
}

function serverToClient2019 (s) {
  const result = {
    id: s.id,
    year: 2019,
    registration: missingDate,
    registrator: s.referent,

    cvt: {
      bio: {},
      reg: {},
      dir: {},

      lastModified: s.chart.date,
      status: s.chart.status,
      error: s.chart.error
    },

    establishment: {
      id: s.establishment.id,
      finess: s.establishment.finess,
      name: s.establishment.name
    },

    modules: {},

    isClosed: function () {
      return s.status === 'closed'
    },

    enableSurvey: function (id) {
      if (!this.isClosed()) {
        return false
      }

      if (this.isRegistrator(id)) {
        return true
      }

      for (let m in this.modules) {
        if (m === 'results') {
          continue
        }

        if (this.findMember(id, m)) {
          return true
        }
      }
      return false
    }
  }

  result.modules.results = {
    members: getMembers(s, 'results')
  }

  if (s.protocols.b) {
    result.modules.bactADI = {
      registration: missingDate,
      empty: s.emptyBactADI,
      members: getMembers(s, 'bactADI')
    }
  }

  if (s.protocols.rb) {
    const bu = unitList.serverToClient2019(s.badiUnits)
    result.modules.reaBactADI = createModule(s, 'reaBactADI', bu)
  }

  if (s.protocols.ri) {
    const units = splitReaNeoDia(unitList.serverToClient2019(s.iadiUnits))
    if (units.rea.length > 0) {
      result.modules.reaInfADI = createModule(s, 'reaInfADI', units.rea)
    }

    if (units.neo.length > 0) {
      result.modules.neoInfADI = createModule(s, 'neoInfADI', units.neo)
    }

    if (units.dia.length > 0) {
      result.modules.diaInfADI = createModule(s, 'diaInfADI', units.dia)
    }
  }
  return result
}

class Surveillance {
  constructor (obj) {
    obj && Object.assign(this, obj)
  }

  hasProtocol (m) {
    return this.modules[m] != null
  }

  getUfs (m) {
    const module = this.modules[m]
    if (module == null) {
      return null
    }

    if (module.srvs != null) {
      return getUfsFromExplaur(module.srvs)
    }

    if (module.ufs != null) {
      return module.ufs.slice()
    }

    return null
  }

  getUf (m, ut, uf) {
    const mod = this.modules[m]
    if (mod == null || mod.ufs == null) {
      return null
    }

    return mod.ufs.find(
      u => u.ufType === ut && u.name === uf
    )
  }

  hasDatasets () {
    for (let k in this.modules) {
      const m = this.modules[k]
      if (m.dset != null && m.dset.length > 0) {
        return true
      }
    }
    return false
  }

  hasDataset (m, name, step) {
    if (!this.hasProtocol(m)) {
      return false
    }

    const dset = this.modules[m].dset
    if (dset == null) {
      return false
    }

    const ds = dset.find(
      d => d.name === name && d.step >= step
    )
    return ds != null
  }

  findMember (id, type) {
    if (!this.hasProtocol(type)) {
      return null
    }
    return this.modules[type].members.find(e => e.user.id === id)
  }

  isRegistrator (id) {
    return this.registrator.id === id
  }

  canManageMembers (id, type) {
    return this.testPermission(id, type, go.perm.p.ManageMembers)
  }

  canEditSheets (id, type) {
    return this.testPermission(id, type, go.perm.p.EditSheets)
  }

  canValidateSheets (id, type) {
    return this.testPermission(id, type, go.perm.p.ValidateSheets)
  }

  canGetStatistics (id, type) {
    return this.testPermission(id, type, go.perm.p.GetStatistics)
  }

  testPermission (id, type, perm) {
    if (this.isRegistrator(id)) {
      return true
    }

    const r = this.findMember(id, type)
    if (r == null) {
      return false
    }

    const list = (this.year === 2019)
      ? go.perm.getPermissionsFromRole(r.role)
      : r.perm[go.units.allUfKey]

    return list.indexOf(perm) !== -1
  }

  isReferent (id, type) {
    if (this.isRegistrator(id)) {
      return true
    }

    const r = this.findMember(id, type)
    return r != null && r.role === 0
  }

  isMember (id, type) {
    if (this.isRegistrator(id)) {
      return true
    }

    return this.findMember(id, type) !== null
  }

  getExplaurLabels () {
    if (this.modules.reaExplaur == null) {
      return []
    }

    const result = []
    const finess = this.establishment.finess
    this.modules.reaExplaur.srvs.forEach(
      s => {
        result.push(
          {
            ut: units[this.year].findFromIndex(s.uf.ufType).code,
            uf: s.uf.name,
            labl: `${finess}-${s.labl}`
          }
        )
      }
    )

    return result
  }

  fillAvalaibleModules (id) {
    const available = []
    const surveillances = []
    const observations = []
    const sheets = []
    const research = []
    const causeAnalysis = []
    const allSurveillances = []
    const allObservations = []
    const allResearchs = []
    const allCauseAnalysis = []

    for (let m in this.modules) {
      const mod = modules[this.year][m]

      const ism = this.findMember(id, m) != null
      if (ism) {
        available.push(m)
      }

      if (mod.sheets != null) {
        if (ism) {
          sheets.push(m)
        }

        switch (mod.type) {
          case modules.types.surveillance:
            allSurveillances.push(m)
            if (ism) {
              surveillances.push(m)
            }
            break

          case modules.types.observation:
            allObservations.push(m)
            if (ism) {
              observations.push(m)
            }
            break

          case modules.types.research:
            if (ism) {
              research.push(m)
            }
            allResearchs.push(m)
            break

          case modules.types.causeAnalysis:
            if (ism) {
              causeAnalysis.push(m)
            }
            allCauseAnalysis.push(m)
            break
        }
      }
    }
    this.availableModules = available
    this.availableSheetModules = sheets
    this.availableSurveillanceModules = surveillances
    this.availableObservationModules = observations
    this.availableResearchModules = research
    this.availableCauseAnalysisModules = causeAnalysis
    this.allSurveillanceModules = allSurveillances
    this.allObservationModules = allObservations
    this.allResearchModules = allResearchs
    this.allCauseAnalysisModules = allCauseAnalysis
  }
}

function addMethods (s) {
  return new Surveillance(s)
}

function getUfsFromExplaur (srvs) {
  let ufs = []
  for (let s in srvs) {
    ufs.push(srvs[s].uf)
  }
  return ufs
}

function updateRequest (r) {
  if (r.target.year === 2019) {
    const protocols = {
      b: r.protocols.bactADI,
      rb: r.protocols.reaBactADI,
      ri: r.protocols.reaInfADI || r.protocols.neoInfADI || r.protocols.diaInfADI
    }

    const result = {
      id: r.target.id,
      p: protocols
    }

    if (protocols.rb) {
      result.bu = unitList.clientToServer2019(r.units.reaBactADI)
    }

    if (protocols.ri) {
      const all = {
        ri: r.units.reaInfADI != null ? r.units.reaInfADI : [],
        ni: r.units.neoInfADI != null ? r.units.neoInfADI : [],
        di: r.units.diaInfADI != null ? r.units.diaInfADI : []
      }
      const units = new Set([...all.ri, ...all.ni, ...all.di])
      result.iu = unitList.clientToServer2019([...units])
    }

    return result
  }

  const result = {
    id: r.target.id,
    mod: {}
  }
  for (let p in r.protocols) {
    if (r.protocols[p]) {
      const module = {}
      if (r.units[p] != null) {
        if (p === 'reaSink') {
          module.uf = r.units[p][0]
        } else {
          module.ufs = r.units[p]
        }
      }
      result.mod[p] = module
    }
  }
  for (let m in r.target.modules) {
    if (r.protocols[m] == null) {
      const module = {}
      if (m === 'reaSink') {
        module.uf = r.target.modules[m].uf
      } else if (m === 'reaExplaur') {
        module.ufs = getUfsFromExplaur(r.target.modules[m].srvs)
      } else {
        module.ufs = r.target.modules[m].ufs
      }
      result.mod[m] = module
    }
  }
  return result
}

export default {
  serverToClient2019: serverToClient2019,
  serverToClient: serverToClient,
  addMethods: addMethods,
  updateRequest: updateRequest
}
